import { createTheme , makeStyles } from "@material-ui/core";
import { Theme } from '@material-ui/core/styles';
const drawerWidth = 320;

export default makeStyles((theme: Theme) => ({
  content: {
      [theme.breakpoints.up('sm')]: {
          paddingRight: drawerWidth,
      },
  },
  accordionRoot: {
    border: 'none',
    boxShadow: 'none',
    '&:before': {
        display: 'none', // this remove the line on top of accordion
    },
    '&.Mui-expanded': {
        margin: 0,
    },
},
accordionExpandIcon: {
transform: 'rotate(0deg)', // Collapsed: points downward
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&.Mui-expanded': {
        transform: 'rotate(180deg)', // Expanded: points upward
    }
},
accordionDetails: {
  paddingTop: 0,
  paddingBottom: 0,
},
iconCollapsed: {
    transform: 'rotate(0deg)', // Points downward
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
},
iconExpanded: {
    transform: 'rotate(180deg)', // Points upward
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
},
 accordionSummaryContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 0,
    minHeight: 0, // Reduce height further
    marginBottom: 0,
},
headerTitleBold: {
    fontWeight: 'bold',
    color: '#000000',
    margin: 0, // Remove margin
},
listHeaderSubTitle: {
    fontSize: '12px',
    color: '#898F91',
    margin: 0, // Remove margin
},
expandIconLeft: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
},
  nested: {
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    backgroundColor: 'inherit', // Remove background
},
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paperTitle: {
    color: '#428302',
  },
  listHeader: {
    padding: 0,
    lineHeight: 0,
    marginBottom: '16px',
    height: '30px'
  },
  serviceTitle: {
    backgroundColor: "#F3F3F3",
    fontSize: 16,
  },
  listItemTitle: {
    fontWeight: 500
  },
  
  paper: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    display: 'contents'
  },
  
  radioButton: {
    padding: theme.spacing(0),
  },
  checkBox: {
    padding: theme.spacing(0),
    // backgroundColor: '#107A98',
    // color: '#107A98'
  },
  radioButtonLabel: {
    fontSize: '0.875rem',
    color: '#000000',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
  },
  siuInfoIcon: {
    fontSize: '1rem',
    color: '#898F91',
    cursor: 'pointer',
    verticalAlign: 'middle',
    '&:hover': {
      color: '#107A98',
    },
  },
  siuTooltip: {
    maxWidth: 360,
    fontSize: '0.8125rem',
    lineHeight: 1.5,
    padding: '8px 12px',
    backgroundColor: '#FFFFFF',
    color: '#4A4A4A',
    border: '1px solid #E0E0E0',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
  },
  siuTooltipArrow: {
    color: '#FFFFFF',
    '&::before': {
      border: '1px solid #E0E0E0',
    },
  },
  vendorsGroup: {
    paddingTop: '8px',
  },
  subtitleDiagnostic: {
    display: 'block',
    fontSize: '14px',
  },
  customMessage:{
    textAlign:'center',
    width:'100%',
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formControlRelative: {
    position: 'relative',
    marginRight: theme.spacing(0.75),
  },
  helperTextAbsolute: {
    position: 'absolute !important' as any,
    bottom: -18,
    left: 0,
    marginTop: '0 !important',
    whiteSpace: 'nowrap',
  },
  facilityTypeMenuItem: {
    minHeight: 32,
    paddingTop: 2,
    paddingBottom: 2,
    color: '#000000',
  },
  selectOptionLabel: {
    fontSize: '0.875rem',
  },
  facilityTypeItemText: {
    margin: 0,
    padding: 0,
    '& .MuiListItemText-primary': {
      fontSize: '0.875rem',
      color: '#000000',
    },
  },
  numberOfDaysContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  numberOfDaysLabel: {
    fontSize: '0.875rem',
    color: '#4A4A4A',
    whiteSpace: 'nowrap',
    lineHeight: 1,
    flexShrink: 0,
  },
  numberOfDaysLabelError: {
    color: '#f44336',
  },
  numberOfDaysInput: {
    minWidth: 50,
    flex: 1,
    position: 'relative',
    marginTop: '0 !important',
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiInput-formControl': {
      marginTop: '0 !important',
    },
    '& .MuiInput-root': {
      marginTop: '0 !important',
    },    
    '& .MuiInput-input': {
      fontSize: '0.875rem',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '12px !important',
      lineHeight: 1,
    },
    '& .MuiInputBase-input': {
      paddingLeft: '10px !important',
    },
    '& input': {
      paddingLeft: '10px !important',
    },
  },
  numberOfDaysHelperText: {
    position: 'absolute !important' as any,
    bottom: -18,
    left: 0,
    marginTop: '0 !important',
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
}));

export const medicalServiceTheme = createTheme ({
  overrides: {
    MuiListItem: {
      root: {
        color: '#004763',
      },
    },
    MuiTypography:{
      body1:{
        fontSize:'0.875rem',
        fontWeight: 500
      }
    },
    MuiIconButton:{
      label:{
        
      }
    },
    MuiSvgIcon:{
      root:{
        marginRight: '16px!important'
      }
    },
    MuiRadio:{
      root:{
        color: '#898F91'
      },
      colorSecondary:{
        '&$checked':{
          color: '#107A98'
        },
        color: '#898F91'
      } 
    },
    MuiCheckbox:{
      root:{
        color: '#898F91'
      },
      colorSecondary:{
        '&$checked':{
          color: '#107A98'
        },
        color: '#898F91'
      } 
    }
  },
});
